<template>
	<div class="container">
		<estrella v-for="(i, index) in 5" :key="`fija-${index}`"></estrella>
		<estrella-fugaz
			v-for="(i, index) in 3"
			:key="`fugaz-${index}`"
		></estrella-fugaz>
		<div class="volver-container">
			<div class="planeta-volver">
				<img
					src="@/assets/img/planetas/planeta_volver.png"
					alt=""
					class="planeta"
					@click="volver"
				/>
				<div class="tooltip">
					<span>{{textoVolver}}</span>
				</div>
			</div>
			<div class="titulo">
				<h1>{{titulo}}</h1>
			</div>
		</div>

		<apps-presidencia
			:eventBus="eventBus"
			:contenidos="contenidos"
			:areas_seleccionadas="areas_seleccionadas"
			:contenido_seleccionado="contenido_seleccionado"
			@seleccionar="seleccionar"
		/>

		<selectores
			:eventBus="eventBus"
			:areas_curriculares="programas_presidencia"
			@filtrar="filtrar"
		/>

		<side-bar-presidencia
			v-if="contenido_seleccionado"
			:logo="logo"
			:eventBus="eventBus"
			:contenidos="contenido_seleccionado.contenidos"
		/>

		<visor-guia
			v-if="contenido_seleccionado"
			:eventBus="eventBus"
			:contenido_seleccionado="contenido_seleccionado"
		/>

		<visor-video
			v-if="contenido_seleccionado"
			:eventBus="eventBus"
		/>
	</div>
</template>
<script>
import Vue from 'vue'
import Estrella from '@/components/Estrella.vue'
import EstrellaFugaz from '@/components/EstrellaFugaz.vue'
import AppsPresidencia from '@/components/AppsPresidencia.vue'
import Selectores from '@/components/Selectores.vue'
import SideBarPresidencia from '@/components/SideBarPresidencia.vue'
import VisorGuia from '@/components/VisorGuia.vue'
import VisorVideo from '@/components/VisorVideo.vue'

import _ from 'lodash'

export default {
	name: 'estudiantes',
	components: {
		Estrella,
		EstrellaFugaz,
		AppsPresidencia,
		Selectores,
		SideBarPresidencia,
		VisorGuia,
		VisorVideo
	},
	data: function () {
		return {
			contenido_seleccionado: null,
			eventBus: new Vue(),
		}
	},
	computed: {
		logo(){
			return this.contenido_seleccionado.id == 200 ? "logo.png" : "presidencia-logo.png";
		},
		textoVolver(){
			return this.$store.getters.tooltips.volver;
		},
		titulo(){
			return this.$store.getters.presidenciaScreen.titulo;
		},
		programas_presidencia () {
			let ac = _.clone(this.$store.getters.programas_presidencia);
			ac.push({
				id: null,
				nombre: "Todas",
				abrev: "TD",
				descripcion: "",
				color: "white",
				seleccionado: true
			});
			return ac;
		},
		areas_seleccionadas () {
			return _.map(_.filter(this.programas_presidencia, function (area) { return area.seleccionado && area.nombre != 'Todas'; }), 'nombre');
		},
		contenidos () {
			return this.$store.getters.contenidosPresidencia;
		},
	},
	methods: {
		seleccionar (contenido) {
			this.contenido_seleccionado = contenido;
		},
		filtrar (area) {
			if (area.seleccionado) { return false }
			_.each(this.programas_presidencia, function (area) { area.seleccionado = false });
			area.seleccionado = true;
		},
		volver () {
			// this.$router.go(-1);
			this.$router.replace({name: 'home'});
		}
	},
	created () {

	},
	mounted () {

	},
	watch: {

	}
}
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/responsiveness.scss";
.container {
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	background-image: url("~@/assets/img/presidencia/Background.png");
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
}

.ladera {
	z-index: 0;
	position: fixed;
	bottom: 0px;
	width: 250px;
	max-width: 30%;
	left: 0px;
}

.logo-cpe {
	position: fixed;
	right: 70px;
	top: 15px;
	width: 150px;
	max-width: 30%;
	opacity: 0.5;
}

.volver-container {
	z-index: 2;
	position: absolute;
	top: 0px;
	left: 0px;
	display: flex;
	flex-direction: row;
}

.volver-container > .planeta-volver {
	width: 150px;
	margin-left: -50px;
	@include mobile {
		width: 100px;
		margin-left: -40px;
	}
}

.volver-container > .planeta-volver > .planeta {
	filter: drop-shadow(0px 0px 10px white);
	cursor: url("~@/assets/img/cursors/pointer.png"), pointer;
	max-width: 100%;
	margin-top: -50px;
	@include mobile {
		margin-top: -40px;
	}
}

.planeta-volver > .tooltip {
	position: absolute;
	left: 90px;
	top: 60px;
	background-color: rgba(173, 192, 0, 1);
	color: white;
	opacity: 0;
	padding-left: 10px;
	padding-right: 10px;
	border-radius: 0px 10px 10px 10px;
	@include mobile {
		left: 50px;
		top: 40px;
	}
}

.planeta:hover + .tooltip {
	opacity: 1;
}

.volver-container > .titulo {
	color: white;
	// line-height: 30px;
	padding: 0px 0px 0px 15px;
	text-align: left;
	@include mobile {
		font-size: 10pt;
	}
	@include mobile-s {
		font-size: 8pt;
	}
}
.volver-container > .titulo > h1 {
	margin: 0px;
	padding: 0px;
	text-shadow: 0px 0px 10px black;
}
</style>
